export default __webpack_public_path__ + "static/media/gallery01.f2cbffe3.png";